import axios from "axios";

const api = axios.create({
  // Relative URLs allow Vite to proxy /api requests during development.
  // In production, requests remain on the current site origin.
  baseURL: "",
  withCredentials: true,
});

export default api;
